<template>
    <b-form :save-url="addUrl" @success="formSuccess" v-slot="{model, loading}" @failure="formFailure"
            :save-params="{api_key: currentUser.api_key}" :initial-data="initialData">

        <div class="row">
            <validated-input class="col-12" label="Heading" name="Heading" v-model="model.heading"
                             :rules="{required:true}" :disabled="loading"/>
        </div>

        <div class="row">
            <file-input class="c-file-input col-12" label="Image" v-model="model.image" :disabled="loading">
                <template #append v-if="model.image">
                    <btn class="ml-auto" type="button" size="xs"
                         title="View Image" @click="viewFile(model.image)"/>
                </template>
            </file-input>
        </div>
        <div class="row">
            <div class="col">
                <image-info :width="380" :height="380"/>
            </div>
        </div>

        <div class="row">
            <validated-textarea class="col-12" label="Para 1" name="Para 1"
                                v-model="model.para_1" :rules="{required:true, min:540, max:560}" :disabled="loading"/>
        </div>

        <div class="row">
            <validated-textarea class="col-12" label="Para 2" name="Para 2" v-model="model.para_2"
                                :rules="{required:true, min:540, max:560}" :disabled="loading"/>
        </div>

        <div class="row">
            <checkbox-input class="col-6" label="Disable" v-model="model.disabled"
                            :rules="{required:false}" :disabled="loading"/>
        </div>

        <btn class="trn" size="sm" :loading="loading" color="primary" text="Save"
             loading-text="Saving..." :disabled="loading"/>
    </b-form>
</template>

<script>
import urls from '../../../../data/urls';
import { mapGetters } from 'vuex';

export default {
    name     : 'EditAboutUsProfile',
    computed : { ...mapGetters(['currentUser']) },
    props    : { initialData : { type : Object } },
    data () {
        return {
            addUrl : urls.admin.event.aboutUsProfile.addEdit
        };
    },

    methods : {
        viewFile (url) {
            window.open(url);
        },
        formSuccess () {
            this.$notify('Successfully Edited About Us Profile..!', 'Success',
                {
                    type : 'success'
                }
            );
            this.$emit('success');
        },

        formFailure (response) {
            const json = response.data;
            if (json.permission === false) {
                this.$notify('Invalid Authentication..!', 'Permission Denied',
                    {
                        type : 'warning'
                    }
                );
            }
        }
    }
};
</script>

<style scoped>

</style>
